<template>
  <div class="instructions">
    <div v-if="groupInstructionsByKeyValue.length">

      <data-tables
          class="first-checkbox"
          :tableClass="tableClass"
          :columns="getColumns"
          :rows="groupInstructionsByKeyValue"
          tableID="instructions-by-key-dt"
          routerLinkClass="dt-router-link"
          :tableInitOptions="getTableInitOptions"
          :customFilters="[]"
      />

    </div>
    <div v-else>
      {{ $t('instructions.noInstructionsFound') }}
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {dataTables} from "@/mixins/dataTables";

export default {
  name: "InstructionsByKey",
  props: ['keyProperty','isWorkflow'],
  mixins: [dataTables],
  data() {
    return {
      searchValue: '',
      tableClass: 'table-striped table-bordered responsive nowrap',
    }
  },
  computed: {
    ...mapGetters('instructions', ['getInstructionByLinkedKey']),
    ...mapGetters('company', ['getConfig']),
    ...mapGetters('workflows', ['getWorkflowName','getWorkflow']),
    getLinkKeysOfCompany() {
      return this.getConfig.instructions ? this.getConfig.instructions.linkKeys : [];
    },
    getTableInitOptions() {
      let options = this.tableInitOptions;
      options.buttons = [];
      return options;
    },
    getInstructionsBySearchValue() {
      const instructions = this.getInstructionByLinkedKey(this.keyProperty,this.isWorkflow)

      return _.filter(instructions, instruction => {
        return _.filter(instruction[this.keyProperty], keyValue => {
          return keyValue.toLowerCase() === this.searchValue.toLowerCase();
        })
      })
    },
    getColumns() {
      let self = this;
      return [
        {
          data: null,
          name: self.getLabelOfLinkKey(self.keyProperty),
          responsivePriority: 1,
          render(data) {
            return self.getValueOfKey(data.keyValue, self.keyProperty);
          }
        },
        {
          data: null,
          name: self.$t('instructions.title'),
          responsivePriority: 1,
          orderable: false,
          render(data) {
            let list = `<ul>`;
            data.instructions.forEach(instruction => {
              list += ` <li>
                          <div class="instruction-table-grid">
                            <a data-to="instructions/edit/${instruction.id}" class="dt-router-link">${instruction.title}</a>
                            <div class="other-links">`;
              self.getLinkKeysOfCompany.forEach(linkKey => {
                if (instruction[linkKey.instructionProperty]) {
                  instruction[linkKey.instructionProperty].forEach(value => {
                    list += `<div data-toggle="tooltip" data-placement="top" title="${self.getLabelOfLinkKey(linkKey.instructionProperty)}" class='other-link-value ${linkKey.instructionProperty}'>${self.getValueOfKey(value, linkKey.instructionProperty)}</div>`
                  })
                }

              })

              list += `    </div>
                         </div>
                        </li>`;
            });
            list += `</ul>`
            return list;
          }
        }]
    },
    groupInstructionsByKeyValue() {
      // Group the instruction per unique value
      // Since its a nested array we need to use reduce with a for-each loop
      // Because _.groupBy only offers the groupby on the full array (meaning combinations would be unique values too, instead of just the values in that combination)
      const reduced = _.reduce(this.getInstructionsBySearchValue, (groupedArray, instruction) => {
        _.forEach(instruction[this.keyProperty], keyValue => {
          if (!groupedArray[keyValue]) {
            groupedArray[keyValue] = {
              keyValue,
              instructions: []
            }
          }
          groupedArray[keyValue].instructions.push(_.clone(instruction))
        })
        return groupedArray
      }, {});
      return _.toArray(reduced);
    },
  },
  created() {
    // Enable tooltips
    $("body").tooltip({ selector: '[data-toggle=tooltip]' });

    this.$store.dispatch('instructions/fetchAndAddByKeys', [this.keyProperty])
  },
  methods: {
    getLabelOfLinkKey(keyProperty) {
      const linkKey = this.getLinkKey(keyProperty);
      return linkKey.label.translated ? this.$t(linkKey.label.value) : linkKey.label.value
    },
    getLinkKey(keyProperty) {
      return _.find(this.getLinkKeysOfCompany, linkKey => {
        return linkKey.instructionProperty === keyProperty;
      })
    },
    getValueOfKey(keyValue, keyProperty) {
      const linkKey = this.getLinkKey(keyProperty);
      if (linkKey.system) {
        // System link keys are linked do document id's in firebase
        // So we need to get the name of dat document
        if (linkKey.source === 'WORKFLOWS') {
          return this.getWorkflowName(keyValue);
        } else {
          // currently only workflows are system link keys that are linked to a document
          return keyValue;
        }
      } else {
        // Non system link keys contain the displaying value directly (for example: product numbers, activities)
        return keyValue;
      }
    },
  },
  watch: {
    'keyProperty': {
      handler() {
        console.log(this.keyProperty)
        this.$store.dispatch('instructions/fetchAndAddByKeys', [this.keyProperty])
      }
    }
  }
}
</script>

<style scoped>
.instructions {
  margin: 1rem;
}




</style>

<style>

.other-links {
  white-space: normal;
}

/*Non scoped style for the key labels*/
.instruction-table-grid {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 2rem;
}


.other-link-value {
  display: inline-block;
  margin-right: 1rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  border-radius: 24px;
  font-weight: bold;
  margin-bottom: 1rem;
}


.other-link-value.key0 {
  background-color: #d7f8ff;
}
.other-link-value.key1 {
  background-color: #e5ffe5;
}
.other-link-value.key2 {
  background-color: #ffd7fa;
}
.other-link-value.key3 {
  background-color: #ffe8d7;
}
.other-link-value.key4 {
  background-color: #fffad7;
}
</style>